import React, { FC } from 'react'

import { IconSmsTextProps } from './IconSmsText.types'
import * as Styled from './styles/IconSmsText.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSmsText: FC<IconSmsTextProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSmsTextProps['size'],
  isResponsive = false,
}: IconSmsTextProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M28.973 17.652V13.5c0-2.484-2.016-4.5-4.5-4.5H9.578a4.501 4.501 0 0 0-4.5 4.5l.024 10c0 2.484 2.011 4.5 4.5 4.5h1.476v5.21l5.02-5.21h2.98'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M23.578 17.969h19.45V32.46' stroke='#0D0D0D' strokeLinecap='round' strokeWidth='2' />
        <path
          d='M43.027 32.46c0 2.49-2.015 4.5-4.5 4.5h-1.425v5.216l-5.024-5.215h-8.5c-2.5 0-4.5-2.012-4.5-4.637v-10c0-2.347 2-4.363 4.5-4.363'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M32.086 28.14a.837.837 0 1 1-1.674-.001.837.837 0 0 1 1.674.002Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M31.5 28.14c0 .137-.113.25-.25.25a.252.252 0 0 1-.25-.25.25.25 0 1 1 .5 0Zm6.586 0a.837.837 0 1 1-1.674-.001.837.837 0 0 1 1.674.002Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M37.5 28.14c0 .137-.113.25-.25.25a.252.252 0 0 1-.25-.25.25.25 0 1 1 .5 0Zm-11.434 0a.838.838 0 1 1-1.675-.003.838.838 0 0 1 1.675.004Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M25.477 28.14a.25.25 0 0 1-.25.25.252.252 0 0 1-.25-.25c0-.14.113-.25.25-.25.14 0 .25.11.25.25Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSmsText
